import { TextAreaAutoSize } from "@/Common/Components/Inputs/TextAreaAutoSize";
import { SharedItemNote } from "@/Common/Models/Portal/SharedItem/SharedItemNote";

import styles from "./PortalCommunicationNotesList.module.scss";

interface IPortalCommunicationNotesList {
    notes: SharedItemNote[];
    isPopup?: boolean;
}

export function PortalCommunicationNotesList(props: Readonly<IPortalCommunicationNotesList>): JSX.Element {
    const notesLength = props.notes.length;

    if (!notesLength)
        return null;

    return (
        <div
            className={`${styles.noteListsContainer} ${props.isPopup ? styles.popupContainer : ""}`}
            data-cy="portal-communication-note-list-container"
        >
            {props.notes.map(noteItem => (
                <div
                    className={styles.noteItemContainer}
                    key={`threadNote_${noteItem.noteId}`}
                    data-cy="portal-communication-note-item"
                >
                    <div className={styles.noteHeader}>
                        <span
                            className={styles.provider}
                            data-cy="portal-communication-note-item-provider"
                        >
                            {noteItem.employeeName}
                        </span>
                        <span data-cy="portal-communication-note-item-date">
                            {noteItem.dateLabel}
                        </span>
                    </div>
                    <TextAreaAutoSize
                        id={`textNote_${noteItem.noteId}`}
                        cssClass={styles.noteTextContainer}
                        value={noteItem.note}
                        disabled
                        dataCy="portal-communication-note-item-note-text"
                    />
                </div>
            ))}
        </div>
    );
}
